module.exports = __webpack_public_path__ + "img/allhouse-white.96f31a14.svg";